import { Button, Card } from "react-bootstrap";
const APP_VARIANT = import.meta.env.VITE_APP_VARIANT;

const EventDetailView = () => {
    return (
        <Card>
            <Card.Body>
                <Card.Title>Event Headline</Card.Title>
                <Card.Text>
                    Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
                </Card.Text>
                <Button variant={APP_VARIANT === 'QS' ? 'secondary rounded-0' : 'primary'} className="">Weiter gehts...</Button>
            </Card.Body>
        </Card>
    );
};

export default EventDetailView;